import React from 'react'
import styled from 'styled-components'
import theme from '@shared/utils/theme'
import { useNavigate } from 'react-router'

const Bar = styled.div`
  flex-grow: 1;
  height: 3px;
  background: ${ props => props.completed ? theme.palette.blue : theme.palette.grey };
`

const Circle = styled.div`
    width: 25px;
    height: 25px;
    background-color: ${ props => props.completed ? theme.palette.blue : theme.palette.grey };
    border-radius: 50%;
    font-size: 16px;
    color: ${ theme.palette.white };
    display: flex;
    align-items: center;
    justify-content: center;
    ${ props => props.completed ? 'cursor: pointer;' : '' }
`
const Step = ({ index, completed, first, isLast, onClick }) => {
  const stepContent = index + 1
  return (
    <React.Fragment>
      { !first && <Bar completed={ completed }/> }
      <Circle completed={ completed }
              onClick={ () => {
                if (completed) {
                  onClick && onClick()
                }
              } }>
        { stepContent }
      </Circle>
      { !isLast && <Bar completed={ completed }/> }
    </React.Fragment>
  )
}

const StepperContainer = styled.div`
  width:100%;
  min-height: 0;
  padding: 0;
  .stepper {
    display: flex;
    width: 100%;
    margin-bottom: 30px;
    align-items: center;
  },
`
const Stepper = ({ activeStep = 0, steps }) => {

  const navigate = useNavigate()
  return (
    steps.length > 0 && <StepperContainer>
      <div className="stepper">
        { steps.map((step, index) => (
          <Step
            key={ 'step_' + index }
            onClick={ () => {
                navigate(step.url)
            } }
            completed={ index <= activeStep }
            index={ index }
            first={ index === 0 }
            isLast={ index === steps.length - 1 }
          />
        )) }
      </div>
    </StepperContainer>
  )
}

export default Stepper
